import { connect } from 'react-redux'
import { getWhoAmI } from '../../common/auth/authActions'
import { setIntegration } from '../../common/integration/integrationActions'
import { IGlobalState } from '../../Root/store/appReducer'
import { getUserCompanyCountries, getCompanyDivisions, updateUser } from '../Settings/store/SettingsActions'
import { IStateProps, RegisterUser } from './RegisterUser'
import { registerUser, updateActivityData, updateProfileData } from './store/RegisterUserActions'
import { getAuthData, getRegisterUserLastUpdate, getUserCompanies } from './store/RegisterUserSelectors'
import { reLocate } from '../../common/Routes/RouterActions'
import { companyCountriesSelector, companyDivisionsSelector } from '../Settings/store/SettingsSelectors'
import { getUserIntegrationScopes } from '../../common/auth/authSelectors'
import {
  getCreatedDivisionId,
  getDivisionCategories,
  getCreatedGroupId,
} from '../TeamManagement/store/TeamManagementSelectors'
import {
  getDivisionCategories as getDivisionCategoriesAction,
  //getDivisionsDeprecated as getDivisionsAction,
} from '../TeamManagement/store/TeamManagementActions'

const mapStateToProps = (state: IGlobalState): IStateProps => {
  return {
    userDto: getAuthData(state),
    userCompanies: getUserCompanies(state),
    countries: companyCountriesSelector(state),
    divisions: companyDivisionsSelector(state),
    divisionCategories: getDivisionCategories(state),
    userIntegrationScopes: getUserIntegrationScopes(state),
    createdDivisionId: getCreatedDivisionId(state),
    //createdGroupId: getCreatedGroupId(state),
    lastUpdate: getRegisterUserLastUpdate(state),
  }
}

const mapDispatchToProps = {
  getWhoAmI,
  registerUser,
  setIntegration,
  updateUser,
  reLocate,
  getUserCompanyCountries,
  getDivisions: getCompanyDivisions,
  getDivisionCategories: getDivisionCategoriesAction,
  updateProfileData,
  updateActivityData,
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterUser)
